import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgHttpLoaderModule } from "ng-http-loader";
import { APP_BASE_HREF, DatePipe } from "@angular/common";

import { AppRoutingModule } from "./app-routing.module";
import { ComponentsModule } from "./pages/components/components.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppComponent } from "./app.component";
import { environment } from "../environments/environment";

import { ApiService } from "./pages/services/api.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MenuService } from "./pages/services/menu.service";
import { AlertsService } from "./pages/services/alerts.service";
import { LocationwisEpService } from "./pages/services/locationwis-ep.service";
import { GetStartedService } from "./pages/services/get-started.service";
import {
  DEFAULT_TIMEOUT,
  defaultTimeout,
  TimeoutInterceptor,
} from "./pages/services/TimeoutInterceptor";
import {
  GlobalErrorHandler,
  RollBarService,
  rollBarFactory,
} from "./pages/services/global-error-handler";
import { Globals } from "./pages/services/globals";
import { Common } from "./pages/components/utils/common";
import { GoogleAnalyticsEventsService } from "./pages/services/google-analytics-events-service";
import { RefferalComponent } from "./pages/refferal/refferal.component";
import { HeaderService } from "./pages/services/header.service";
import { WhatsAppGuard } from "./auth/whats-app.guard";
import { DataService } from "./pages/services/data.service";
import { ReportingPasswordService } from "./pages/services/reporting-password.service";
import { AuthService } from "./services/auth.service";
import { NotificationService } from "./pages/services/notification.service";
import { RoleGuardService } from "./guards/role-guard.service";
import { PermissionGuard } from "./guards/permission.guard";
import { WindowRef } from "./pages/services/windowRef";
import { ToastrModule } from "ngx-toastr";
import {
  MatLegacyDialogModule as MatDialogModule,
  MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS,
} from "@angular/material/legacy-dialog";
import { DragulaModule } from "ng2-dragula";
import { SmtAuthGaurd } from './auth/smartech-auth';
import { DatePickerService } from "./pages/services/date-picker-services";
import { XlsxServiceService } from "./pages/services/xlsx-service.service";
import { HttpModule } from "@angular/http";
import { NgSelectModule } from '@ng-select/ng-select';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    ComponentsModule,
    NgbModule,
    NgSelectModule,
    MatDialogModule,
    ToastrModule.forRoot(),
    DragulaModule.forRoot(),
    HammerModule,
    NgHttpLoaderModule.forRoot(),
    HttpModule,
    OverlayModule,
    PortalModule
  ],
  providers: [
    GetStartedService,
    ApiService,
    AuthService,
    RoleGuardService,
    PermissionGuard,
    WhatsAppGuard,
    Common,
    Globals,
    GoogleAnalyticsEventsService,
    { provide: APP_BASE_HREF, useValue: `${environment.basePath}` },
    MenuService,
    AlertsService,
    NotificationService,
    LocationwisEpService,
    HeaderService,
    DataService,
    ReportingPasswordService,
    DatePickerService,
    XlsxServiceService,
    DatePipe,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true},
    {provide: DEFAULT_TIMEOUT, useValue: defaultTimeout},
    {provide: RollBarService, useFactory: rollBarFactory},
    WindowRef,
    SmtAuthGaurd,
    HttpClientModule
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
